export const getUserAgent = (navigator: Navigator) => {
  return navigator.userAgent
}
